import { render, staticRenderFns } from "./AccountsAdd.vue?vue&type=template&id=0badadd1"
import script from "./AccountsAdd.vue?vue&type=script&lang=js"
export * from "./AccountsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports